<template>
  <div>
    <modal id="confirmationModal" class="confirmation-modal" width="502px"   :value="showModal" effect="fade" @closed="closed"  large>
      <!-- custom header -->
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title" style="">

          <strong>管理番号'{{linkNumber}}'を割り当てます。割り当てるライセンス数を入力してください。</strong>
        </h4>
      </div>
      <div  class="modal-body confirmation-modal-body " :style="'Width: 201px;padding: 5px 15px; '">

        <span v-if="maxQty" style='float: right;font-weight: 800;'>ライセンス残数: {{maxQty}}</span>
        <br>
        <br>
        <span style='float: right;font-weight: 800;padding: 7px;'>本</span>
        <input type="number" min="1" :max="maxQty" 
        v-model="selectedValue"
        class="form-control"  style="width:60px;float: right;">
        <span style='float: right;font-weight: 800;padding: 7px;'>割り当てるライセンス数：</span>

        <br>
        <br>
        <span style="color:red;">※割り当てるライセンス数はライセンス残数以下の数量しか指定できません</span>
      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <button type="button" :class="'btn btn-default '" @click="closed('no')">戻る</button>
        <button type="button" 
        :class="'confirmation-modal-footer-yes-btn btn btn-primary'" 
        id="confirmationModalYes" 
        @click="confirmOK">OK</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import uuid from "uuid";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
var vm = this;

import  modal  from "./local-modal";
Vue.component("modal", modal);

import debug from "debug";
var debug_msg = debug("esma:confirmation-modal");

export default {
  data() {
    return {
      selected_value:"",
      show_modal: false,
      link_number:false,
      max_qty:false,
    };
  },
  computed: {
    selectedValue:{
      get(){
        return this.selected_value;
      },
      set(v){
        this.selected_value = v;
      }
    },
    linkNumber:{
      get(){
        return this.link_number;
      },
      set(v){
        this.link_number = v;
      }
    },
    maxQty:{
      get(){
        return this.max_qty;
      },
      set(v){
        this.max_qty = v;
      }
    },
    showModal() {
      return this.show_modal;
    }
  },
  methods: {
    confirmOK(){
      this.$notify({clean:true});
        if(this.maxQty =="-"){
          this.closed('yes',this.selectedValue )
        }else if(parseInt(this.selectedValue) > 0 && parseInt(this.selectedValue) <= parseInt(this.maxQty)){
          this.closed('yes',this.selectedValue )
        }else{
          this.$notify({
            title: "エラー",
            text: "割り当てるライセンス数がライセンス残数を上回っています。",
            type: "error",
            duration: 10000
          });
        }
    },
    showModalWindow(data) {
      this.selectedValue = "";
      this.linkNumber = data.link_number || "***";
      this.maxQty = data.max_qty || false;
      this.show_modal = true;

    },
    closed(mode,qty=false) {
        console.log("mode",mode)
        this.show_modal = false;
        this.$emit('done',mode,qty);
    }
  },
  props: {
    tag: { type: String, default: "showConfimationModal" }
  },
  mounted() {
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  }
};
</script>
<style scoped>




.info_div {
  width: 32%;
  float: left;
}
.esma_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.esma_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// confirmation-modal-device-link.vue?83ea54cc